import React, { useEffect, useRef, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { debounce } from 'lodash';
import setUiMessage from '../../Utilities/Tostify';
import AlertDialog from '../../Utilities/AlertDialog';

function SelectMultiProcCode({
  rendercommonFormData,
  calback,
  unitArr,
  prefProc,
  patLabOrder,
  patientId,
}) {
  const inputRef = useRef(null);
  const [unit, setUnit] = useState(1);
  const [procFrom, setProcFrom] = useState(
    parseInt(rendercommonFormData?.procedureForm) || 2
  );
  //const [procFrom, setProcFrom] = useState(2);
  // const [procList, setProcList] = useState(
  //   rendercommonFormData?.id === '' ? [] : rendercommonFormData?.procedure || []
  // );
  const [procList, setProcList] = useState(
    rendercommonFormData?.procedure || []
  );
  const [procCode, setProcCode] = useState('');
  const [procType, setProcType] = useState(1);
  const [pocSerVal, setPocSerVal] = useState(
    rendercommonFormData?.id === '' &&
      rendercommonFormData?.procedure &&
      rendercommonFormData?.procedure.length > 0
      ? rendercommonFormData?.procedure[0]?.procName
      : ''
  );

  const [showProcDd, setShowProcDd] = useState(1);
  const [allData, setAllData] = useState([]);
  const [selected, setSelected] = useState(
    rendercommonFormData?.id === '' &&
      rendercommonFormData?.procedure &&
      rendercommonFormData?.procedure.length > 0
      ? rendercommonFormData?.procedure[0]?.procName
      : ''
  );

  const [temp, setTemp] = useState(
    rendercommonFormData?.id === '' &&
      rendercommonFormData?.procedure &&
      rendercommonFormData?.procedure.length > 0
      ? [
          rendercommonFormData?.procedure[0]?.procId,
          rendercommonFormData?.procedure[0]?.procName,
          rendercommonFormData?.procedure[0]?.unit,
          rendercommonFormData?.procedure[0]?.evaluateCodeId,
        ]
      : []
  );
  const [alertDialoguePopup, setAlertDialoguePopup] = useState(false);
  const [alertDialogueMsg, setAlertDialogueMsg] = useState('');

  const handelProcSelect = (val, text, unit, ecid) => {
    setShowProcDd(true);
    setPocSerVal(text);
    setSelected(text);
    setTemp([val, text, unit, ecid]);
  };

  const removeProcChild = (id) => {
    if (procList.length > 0) {
      setProcList(procList.filter((item) => item?.procId !== id));
    }
  };
  useEffect(() => {
    calback(procList, procFrom);
  }, [calback, procList, procFrom]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef?.current.contains(event.target)) {
        setShowProcDd(true);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [inputRef]);

  useEffect(() => {
    let isCancelled = false;
    const debouncedFetchResults = debounce(async (term) => {
      try {
        const response = await post(
          'api/patient/progressNote/getProcedureListForDropdown',
          {
            term: term,
            searchCodeType: procType,
            patientId: patientId,
            searchMode: 'counselling',
          }
        );
        if (!isCancelled && response.status === 200) {
          setShowProcDd(true);
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      } finally {
        setShowProcDd(false);
      }
    }, 500);

    if (
      pocSerVal.trim() !== '' &&
      selected !== pocSerVal &&
      pocSerVal.trim().length >= 3
    ) {
      debouncedFetchResults(pocSerVal);
    } else {
      setAllData([]);
    }

    return () => {
      isCancelled = true;
      debouncedFetchResults.cancel(); // Cancel any pending debounce on cleanup
    };
  }, [patientId, pocSerVal, procType, selected]);

  const handleSelectedProvCode = () => {
    let procedureId = '';
    if (!unit) {
      setUiMessage('war', 'Please selec unit');
    } else if (procFrom === 1 && !procCode) {
      setUiMessage('war', 'Please selec procedure code');
    } else if (procFrom === 2 && !procCode) {
      setUiMessage('war', 'Please selec procedure code');
    } else if (procFrom === 3 && !temp[0]) {
      setUiMessage('war', 'Please selec procedure code');
    } else {
      if (procFrom === 1) {
        let patProcListArr = patLabOrder.find((item) => item.id === procCode);
        let idFound =
          procList.length > 0 &&
          procList?.some((item) => item?.procId === procCode);
        if (idFound) {
          setUiMessage('inf', 'Procedure code already exist.');
        } else {
          setProcList([
            ...procList,
            {
              procId: procCode,
              procName: patProcListArr?.orderName,
              evaluateCodeId: '0',
              unit: unit,
            },
          ]);
          procedureId = procCode;
        }
      } else if (procFrom === 2) {
        let prefProcListArr = prefProc.find((item) => item.id === procCode);
        let idFound =
          procList.length > 0 &&
          procList?.some((item) => item?.procId === procCode);

        if (idFound) {
          setUiMessage('inf', 'Procedure code already exist.');
        } else {
          setProcList([
            ...procList,
            {
              procId: procCode,
              procName: prefProcListArr?.orderName,
              evaluateCodeId: '0',
              unit: unit,
            },
          ]);
          procedureId = procCode;
        }
      } else if (procFrom === 3) {
        let idFound =
          procList.length > 0 &&
          procList?.some((item) => item?.procId === temp[0]);

        if (idFound) {
          setUiMessage('inf', 'Procedure code already exist.');
        } else {
          setProcList([
            ...procList,
            {
              procId: temp[0],
              procName: temp[1],
              evaluateCodeId: temp[3],
              unit: unit,
            },
          ]);
          procedureId = temp[0];
        }
      }
      handleProcFrom(procFrom);
      (async () => {
        if (patientId && procedureId) {
          try {
            const response = await post(
              'api/patient/ManagePriorAuth/chkPriorAuthNotify',
              {
                patientId: patientId,
                tov: '',
                resourceId: '',
                procedureId: procedureId,
                appId: '',
              }
            );
            if (response.status === 200) {
              if (response?.data?.alert === '1') {
                setAlertDialogueMsg(response?.data?.msg);
                setAlertDialoguePopup(true);
              }
            }
          } catch (error) {
            setUiMessage('err', error?.message);
          }
        }
      })();
      //calback(procList);
    }
  };

  const handleProcFrom = (num) => {
    setProcFrom(num);
    setProcCode('');
    setProcType(1);
    setTemp([]);
    setPocSerVal('');
    setUnit(1);
  };

  return (
    <>
      <span className="pop-up-sb-hdr">Select Service Code</span>
      <div className="appt-hx-fa-rw">
        <input
          type="radio"
          name="prefType"
          className="clear-right10"
          checked={procFrom === 1}
          onChange={() => handleProcFrom(1)}
          disabled={rendercommonFormData?.serviceFlag === '1' ? true : false}
        />
        Patient
        <input
          type="radio"
          name="prefType"
          className="clear-right10 clear-left10"
          checked={procFrom === 2}
          onChange={() => handleProcFrom(2)}
          disabled={rendercommonFormData?.serviceFlag === '1' ? true : false}
        />
        Preferred
        <input
          type="radio"
          name="prefType"
          className="clear-right10 clear-left10"
          checked={procFrom === 3}
          onChange={() => handleProcFrom(3)}
          disabled={rendercommonFormData?.serviceFlag === '1' ? true : false}
        />
        Master
      </div>
      <div className="appt-hx-fa-rw" style={{ width: '65%', float: 'left' }}>
        {(procFrom === 1 && (
          <span className="width100">
            <select
              className="cpt-dd"
              value={procCode}
              onChange={(e) => setProcCode(e.target.value)}
            >
              <option value="">{''}</option>
              {patLabOrder?.map((data, i) => (
                <option key={i} value={data.id}>
                  {data?.orderName}
                </option>
              ))}
            </select>
          </span>
        )) ||
          (procFrom === 2 && (
            <span className="width100">
              <select
                className="cpt-dd"
                value={procCode}
                onChange={(e) => setProcCode(e.target.value)}
              >
                <option value="">{''}</option>
                {prefProc?.map((data, i) => (
                  <option key={i} value={data.id}>
                    {data?.orderName}
                  </option>
                ))}
              </select>
            </span>
          )) ||
          (procFrom === 3 && (
            <span ref={inputRef} className="width100">
              <div style={{ position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <select
                    value={procType}
                    onChange={(e) => setProcType(e.target.value)}
                    className="book-appt-dd"
                    style={{ width: '35%', marginRight: '10px' }}
                    disabled={
                      rendercommonFormData?.serviceFlag === '1' ? true : false
                    }
                  >
                    <option value={1}>CPT/HCPCS</option>
                    <option value={2}>SNOMED</option>
                    <option value={3}>LOINC</option>
                  </select>
                  <input
                    type="serch"
                    value={pocSerVal}
                    onChange={(e) => setPocSerVal(e.target.value)}
                    className="cpt-master-search"
                    style={{ width: '58%', borderRadius: '5px' }}
                    disabled={
                      rendercommonFormData?.serviceFlag === '1' ? true : false
                    }
                  />
                </div>

                <div className={`proc-list-dd ${showProcDd ? 'hide' : ''}`}>
                  {allData &&
                    allData.map((item, i) => (
                      <div
                        key={i}
                        style={{
                          padding: '10px',
                          borderBottom: '1px solid #ccc',
                        }}
                        onClick={() =>
                          handelProcSelect(
                            item?.id,
                            item?.name,
                            item?.unit,
                            item?.evaluateCodeId
                          )
                        }
                      >
                        {item.name}
                      </div>
                    ))}
                </div>
              </div>
            </span>
          ))}
      </div>
      <div className="" style={{ float: 'left', marginTop: '-21px' }}>
        <span
          className="plan-eNm-lbl"
          style={{ float: 'left', marginTop: '6px', width: '55px' }}
        >
          <span style={{ float: 'right' }}>Unit:</span>
          <span className="value" style={{ float: 'left', width: '55px' }}>
            <select
              className="mod-dd"
              style={{ width: '100%' }}
              value={unit || 1}
              onChange={(e) => setUnit(e.target.value)}
            >
              {/* <option value=""></option> */}
              {unitArr.length > 0 &&
                unitArr?.map((data, i) => (
                  <option key={i} value={data?.id}>
                    {data?.val}
                  </option>
                ))}
            </select>
          </span>
        </span>
        <button
          className="actn-yes wbold"
          title="Add more services"
          onClick={() => handleSelectedProvCode()}
          style={{
            qwidth: '45px',
            margin: '22px 0px 0px 10px',
            float: 'left',
            padding: '3px 14px',
          }}
        >
          Add
        </button>
      </div>
      {procList.length > 0 && (
        <div
          className="clear-top10"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border: '1px solid #cfdab5',
            padding: '0px 5px',
            width: 'calc(100% - 17px)',
          }}
        >
          {procList.length > 0 &&
            procList?.map((item, i) => (
              <div
                key={i}
                className="popup-header-body-left-row-value width100"
              >
                <span className="docu-email-inpt-box">{`(${item?.unit}) ${item?.procName}`}</span>
                <span
                  className="docu-email-del"
                  onClick={() => removeProcChild(item?.procId)}
                >
                  X
                </span>
              </div>
            ))}
        </div>
      )}
      {alertDialoguePopup && (
        <AlertDialog
          title="Alert"
          bodytext={alertDialogueMsg}
          successDialog={() => setAlertDialoguePopup(false)}
        />
      )}
    </>
  );
}

export default SelectMultiProcCode;
